import React, {FC} from 'react';

import {FormTable} from 'components/table/form-table';
import {IPageTemplateProps} from 'pages';

interface IFormTablePageProps extends IPageTemplateProps {}

export const FormTablePage: FC<IFormTablePageProps> = ({
    entityName,
    url,
    hideTitle,
    entityType,
}: IFormTablePageProps) => (
    <FormTable
        entityName={entityName}
        entityType={entityType}
        url={url}
        hideTitle={hideTitle}
    />
);
